import React from 'react';
import './circleindeterminateprogress.css';
export default class CircleIndeterminateProgress extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return React.createElement("progress", { className: 'pure-material-progress-circular', style: this.props.style });
    }
}
//# sourceMappingURL=circleindeterminateprogress.js.map